<template>
    <div id="HeaderAdm">
        <b-navbar toggleable="md" type="dark" variant="info" class="hdr">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item @click="showItemsList()"><b>{{$t('NEWS')}}</b></b-nav-item>
                    <b-nav-item @click="showTravels()"><b>{{$t('TRAVELS')}}</b></b-nav-item>
                    <b-nav-item @click="showOffers()"><b>{{$t('OFFERS')}}</b></b-nav-item>
                    <b-nav-item @click="showAuthorsList()"><b>{{$t('AUTHORS')}}</b></b-nav-item>
                    <b-nav-item @click="showRequests()"><b>{{$t('PUB_REQ')}}</b></b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('USERS')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showUsersList(Cnst.UNBLOCKED)">{{$t('UNBLOCKED')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUsersList(Cnst.BLOCKED)">{{$t('BLOCKED')}}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('COMPANIES')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showCompaniesList(true)">{{$t('ALL')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showCompaniesGeo()">GEO_SET</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showCompaniesList(false)">GEO_NOT_SET</b-dropdown-item>
                        <b-dropdown-item href="#" @click="createCompany()">{{$t('CREATE')}}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('PLACES')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showUserPlacesList(Cnst.PUBLISHED, Cnst.UNBLOCKED)">{{$t('PUBLISHED')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserPlacesList(Cnst.UNPUBLISHED, Cnst.UNBLOCKED)">{{$t('UNPUBLISHED')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserPlacesList(Cnst.ALL, Cnst.BLOCKED)">{{$t('BLOCKED')}}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('TRIPS')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showUserTripsList(Cnst.PUBLISHED, Cnst.UNBLOCKED)">{{ $t('PUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserTripsList(Cnst.UNPUBLISHED, Cnst.UNBLOCKED)">{{ $t('UNPUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserTripsList(Cnst.ALL, Cnst.BLOCKED)">{{ $t('BLOCKED') }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('OUTINGS')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showUserOutingsList(Cnst.PUBLISHED)">{{ $t('PUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserOutingsList(Cnst.UNPUBLISHED)">{{ $t('UNPUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserOutingsList(Cnst.ALL, Cnst.BLOCKED)">{{ $t('BLOCKED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="createOuting()">{{ $t('CREATE') }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('CMNTS')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="showUserCmntsList(Cnst.PUBLISHED, Cnst.UNBLOCKED)">{{ $t('PUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserCmntsList(Cnst.UNPUBLISHED, Cnst.UNBLOCKED)">{{ $t('UNPUBLISHED') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showUserCmntsList(Cnst.ALL, Cnst.BLOCKED)">{{ $t('BLOCKED') }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item @click="manageGeo()"><b>Geo</b></b-nav-item>
                    <b-nav-item-dropdown>
                        <template v-slot:button-content>
                            <b>{{$t('MISC')}}</b>
                        </template>
                        <b-dropdown-item href="#" @click="misc('buildSiteMap')">{{ $t('BLD_SMAP') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="misc('clearCapts')">{{ $t('CL_CAPTS') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="misc('setPubItems')">{{ $t('SET_PUB_ITEMS') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="showLog()">{{ $t('SHOW_LOG') }}</b-dropdown-item>
                        <b-form-input v-model="logNum" placeholder="20"></b-form-input>
                        <b-dropdown-item href="#" @click="createUser()">{{ $t('REG') }}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="misc('buildStat')">buildStat</b-dropdown-item>
                        <b-dropdown-item href="#" @click="misc('rmUrlStat')">rmUrlStat</b-dropdown-item>
                        <b-dropdown-item href="#" @click="misc('statWiki')">statWiki</b-dropdown-item>
                        <!--
                        <b-dropdown-item href="#" @click="pathToStat">pathToStat</b-dropdown-item>
                        <b-form-input v-model="path"></b-form-input>
                        -->
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown right>
                        <template v-slot:button-content>
                            <b-avatar :src="avatarUrl" size="1.4em"></b-avatar>
                        </template>
                <b-dropdown-item @click="$logout()"><b>{{$t('SIGN_OUT')}}</b></b-dropdown-item>
                        <b-dropdown-item href="#" @click="$chIntLoc('ru')"><button class="btn"><img src="./imgs/ru.png" alt="ru"></button>ru</b-dropdown-item>
                        <b-dropdown-item href="#" @click="$chIntLoc('en')"><button class="btn"><img src="./imgs/en.png" alt="en"></button>en</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>


        <div class="modalLog">
            <b-modal id="modalLog" size="xl" no-close-on-backdrop>
                <span v-html="log"></span>
                <template v-slot:modal-footer="">
                    <b-button variant="success" @click="$bvModal.hide('modalLog')">Ok</b-button>
                </template>
            </b-modal>
        </div>


    </div>

</template>

<script>
import { BNavbar, BCollapse, BNavbarToggle, BNavbarNav, BNavItem, BDropdownItem,
    BNavItemDropdown, BAvatar, BFormInput, BModal } from 'bootstrap-vue';
import {Cnst} from '@/plugins/Cnst.js';

export default {
  name: 'HeaderAdm',
  components: {
      BNavbar, BCollapse, BNavbarToggle, BNavbarNav, BNavItem, BDropdownItem, BNavItemDropdown, BAvatar, BFormInput, BModal
  },
  data: function() {
    return {
        key: 0,
        msg: '',
        placeName: '',
        intLoc: '',
        log: '',
        logNum: 20,
        // path: '',
        avatarUrl: 'data/avat/foo.png'
      }
    },
  created() {
      this.Cnst = Cnst;
  },
  mounted() {
      if(this.$store.state.curUserName!='admin') this.$showErr(this.$t('YOUR_CMNT'), 401);
      else this.getUserR();
  },
  methods: {
    async getUserR() {
        try {
            const response = await this.$http.get('/getUserR', {
                params: {
                    userName: this.$store.state.curUserName
                }
            });
            this.$store.commit('setCurPos',
                { 'zoom': response.data.curZoom, 'lat': response.data.curLat, 'lng': response.data.curLng } );
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
            this.$store.commit('setCurUserName', '');
            this.$router.push({ path: '/' }).catch(() => {});
        }
    },
    chngIntLoc(newLoc) {
        this.$i18n.locale = newLoc;
        this.intLoc = newLoc;

    },
    showItemsList() { this.$router.push({ path: '/ItemList' }).catch(() => {}) },
    showAuthorsList() { this.$router.push({ path: '/AuthorsList' }).catch(() => {}) },
    showUsersList(blocked) {
        this.$router.push({
            path: '/UsersList',
            query: {
                blocked: blocked
            }
        }).catch(() => {})
    },
    createCompany() {
        this.$router.push({
            path: '/ManageCompany/_'
        });
    },
    showUserPlacesList(published, blocked) {
        if(!this.$store.state.userName) {
            alert('choose user');
            return;
        }
        this.$router.push({
            path: '/UserPlacesList/' + this.$addEncHyp(this.$store.state.userName),
            query: {
                published: published,
                blocked: blocked,
                free: 'false'
            }
        }).catch( () => {} );
    },
    showUserTripsList(published, blocked) {
        if(!this.$store.state.userName) {
            alert('choose user');
            return;
        }
        this.$router.push({
            path: '/UserTripsList/'+this.$addEncHyp(this.$store.state.userName),
            query: {
                published: published,
                blocked: blocked
            }
        }).catch( () => {} )
    },
    showUserOutingsList(published, blocked) {
        if(!this.$store.state.userName) {
            alert('choose user');
            return;
        }
        this.$router.push({
            path: '/UserOutingsList/'+this.$addEncHyp(this.$store.state.userName),
            query: {
                published: published,
                blocked: blocked
            }
        }).catch( () => {} )
    },
    showUserCmntsList(published, blocked) {
        if(!this.$store.state.userName) {
            alert('choose user');
            return;
        }
        this.$router.push({
            path: '/UserCmntsList/'+this.$addEncHyp(this.$store.state.userName),
            query: {
                published: published,
                blocked: blocked
            }
        }).catch( () => {} )
    },
    showTravels() { this.$router.push({  path: '/TravelGeo' }).catch( () => {} ) },
    showOffers() { this.$router.push({  path: '/OffersGeo' }).catch( () => {} ) },
    manageGeo() { this.$router.push({  path: '/ManageGeo' }).catch( () => {} ) },
    showCompaniesList(all) { this.$router.push({ path: '/CompaniesList', query: { all: all } }).catch( () => {} ) },
    showCompaniesGeo() { this.$router.push({  path: '/CompaniesGeo' }).catch( () => {} ) },
    showRequests() {
        this.$router.push({
            path: '/Requests'
        }).catch( () => {} )
    },
    async misc(action) {
        try {
            await this.$http.get('/'+action);
            this.$showMsg(this.$t('DONE'));
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('HeaderAdm: misc() action='+action+' '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async showLog() {
        try {
            const response = await this.$http.get('/getLog', {
                params: {
                    logNum: this.logNum
                }
            });
            this.log = response.data;
            this.$bvModal.show('modalLog');
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
/*
    async pathToStat() {
        try {
            await this.$http.get('/pathToStat', {
                params: {
                    path: this.path
                }
            });
            this.$showMsg(this.$t('DONE'));
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
*/
    createUser() {
        this.$router.push({ path: 'CreateUser' });
    },
    createOuting() {
        this.$router.push({
            path: '/ManageOuting/_'
        });
    },

/*
    async truncDb() {
        try {
            await this.$http.get('/truncDb');
            this.$showMsg(this.$t('DONE'));
        }
        catch(error) {
            if(typeof error.response === 'undefined') alert(error);
            else this.$showErr(error.response.data, error.response.status);
        }
    }
*/
  }
}

</script>

<style>
</style>
